import {
  AvailabilityFeature,
  DistributionAttendeesList,
  MultipleRoundRobinMeetingStartTimes,
  RoundRobinAvailableAttendees,
  RoundRobinExpectedHostV2,
  UsersCombinedMeetingStartTimes,
} from '@chilipiper/api-client/src/user-availability'
import { MeetingLimitSource } from './helpers/meeting-host-limit'

type MeetingTypeOverride = {
  meetingDurationOverride?: string
  beforeBufferDurationOverride?: string
  afterBufferDurationOverride?: string
}

type BaseAvailabilityOptions = {
  additionalRequiredAttendees?: string[]
  meetingTypeOverride?: MeetingTypeOverride
  feature?: AvailabilityFeature
  meetingTypeId: string
  meetingTypeVersion?: string
  tenantId: string
  loadedWeek?: number
}

export type IntervalOptions = {
  availabilityEndsAt: string
  intervalDuration?: string
  intervalStartsAt: string
}

type AssigneeExpectedHost = { type: 'Assignee' }

export type UserExpectedHost = { userId: string; type: 'User' }

export type ExpectedHost = AssigneeExpectedHost | UserExpectedHost

//NEW TYPES
// Case which we would have a host or multiples required users + required attendees (optional)
export type UsersAvailability = {
  expectedHost: ExpectedHost
  userIds: string[]
  meetingLimit?: MeetingLimitSource
  additionalRequiredAttendees?: string[]
}

// Case with multiple assigneeIds + required attendees (optional)
/**
 * @deprecated This type is no longer used - should be removed after we implement multiple
 *   assignments to handoff
 */
export type FlexibleRoundRobinAvailability = {
  assigneeIds: string[]
  distributionId: string
  additionalRequiredAttendees?: string[]
  expectedHost: ExpectedHost
}

// Case strict round robin + required attendees (optional)
/**
 * @deprecated This type is no longer used - should be removed after we implement multiple
 *   assignments to handoff
 */
export type StrictRoundRobinAvailability = {
  rankedAssigneeIds: string[]
  distributionId: string
  additionalRequiredAttendees?: string[]
  expectedHost: ExpectedHost
}

export type MultiRoundRobinAvailability = {
  additionalRequiredAttendees?: string[]
  expectedHost: RoundRobinExpectedHostV2
  ownershipAndUsersAttendees: string[]
  distributionAttendees: DistributionAttendeesList[]
}

export type DistributionAvailabilityOptions = MultiRoundRobinAvailability

export type AvailabilityOptions = MultiRoundRobinAvailability | UsersAvailability

export type UserRequestAvailability = BaseAvailabilityOptions & UsersAvailability

export type MultiRoundRobinRequestAvailability = BaseAvailabilityOptions &
  MultiRoundRobinAvailability

export type SlotsMutationOptions = BaseAvailabilityOptions & {
  availabilityOptions?: AvailabilityOptions
} & Partial<IntervalOptions>

export type GetAvailabilityOptions = UserRequestAvailability | MultiRoundRobinRequestAvailability

export type RequestAvailabilityOptions = BaseAvailabilityOptions & IntervalOptions

export type MeetingStartTimes = UsersCombinedMeetingStartTimes | MultipleRoundRobinMeetingStartTimes

export type SelectTimeSlotParams = {
  slot: string
  timezone?: string
  availableRoundRobinAssignees: RoundRobinAvailableAttendees[]
  userIds: string[]
}

export type GuestFormValues = {
  [key: string]: string | string[]
}

export const isUsersCombinedMeetingStartTimes = (
  timeSlot?: MeetingStartTimes
): timeSlot is UsersCombinedMeetingStartTimes => !!timeSlot && 'userIds' in timeSlot

export const isUserExpectedHost = (
  expectedHost?: ExpectedHost
): expectedHost is UserExpectedHost => {
  return expectedHost?.type === 'User'
}
